<script setup lang="ts">
import openatomLogo from '../../../assets/openatom-white.svg';
</script>

<template>
  <footer class="cl-footer">
    <div class="cl-footer-container">
      <div class="cl-footer-main">
        <div class="cl-footer-brand">
          <img class="cl-footer-logo" :src="openatomLogo" alt="开放原子开源基金会">
          <p>面向开发者、工程师、学生及开源技术从业者，建立覆盖不同技术方向与能力等级的专业人才认证体系。</p>
        </div>
        <div class="cl-footer-contact">
          <div class="cl-contact-title">📮 联系方式</div>
          <div class="cl-contact-row">
            <span class="ico">✉</span>
            <span>教育邮箱：<a href="mailto:education@openatom.org">education@openatom.org</a></span>
          </div>
        </div>
      </div>
      <div class="cl-footer-bottom">
        <p>
          © 2026 开放原子开源基金会 · 人才认证考试报名 | 京ICP备2020036654号-10
          <span class="cl-footer-divider">|</span>
          <RouterLink class="cl-footer-privacy-link" to="/notice">考试报名须知</RouterLink>
          <span class="cl-footer-divider">|</span>
          <RouterLink class="cl-footer-privacy-link" to="/privacy">隐私政策</RouterLink>
        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.cl-footer {
  --cl-blue-900: #071426;
  --cl-cyan: #00b7ff;
  --cl-white: #fff;
  position: relative;
  padding: 24px 0 16px;
  color: rgba(255, 255, 255, 0.55);
  background: var(--cl-blue-900);
}

.cl-footer::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--cl-cyan), transparent);
  content: "";
}

.cl-footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.cl-footer-main {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}

.cl-footer-brand {
  display: flex;
  flex-direction: column;
  max-width: 560px;
}

.cl-footer-logo {
  display: block;
  width: 184px;
  height: auto;
  margin-bottom: 10px;
}

.cl-footer-brand p {
  font-size: 13px;
  line-height: 1.7;
}

.cl-footer-contact {
  padding-top: 4px;
}

.cl-contact-title {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 8px;
  color: var(--cl-white);
  font-weight: 700;
  font-size: 13px;
}

.cl-contact-row {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  line-height: 1.6;
}

.cl-contact-row .ico {
  flex-shrink: 0;
  color: var(--cl-cyan);
  font-size: 13px;
  line-height: 1.6;
}

.cl-footer-contact a {
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.2s;
}

.cl-footer-contact a:hover {
  color: var(--cl-cyan);
}

.cl-footer-bottom {
  padding-top: 14px;
  font-size: 12px;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.cl-footer-divider {
  margin: 0 8px;
}

.cl-footer-privacy-link {
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.2s;
}

.cl-footer-privacy-link:hover {
  color: var(--cl-cyan);
}

@media (max-width: 600px) {
  .cl-footer-main {
    flex-direction: column;
    gap: 16px;
  }
}
</style>
